import { sendGTMEvent } from '@next/third-parties/google'
import { GTM_EVENT_CATEGORY } from '@/lib/tracking/types/GTM_EVENT_CATEGORY'
import { GTMEventBase } from '@/lib/tracking/types/GTMEventBase'
import { GTMEventMap } from '@/lib/tracking/types/GTMEventMap'
import { GTM_CONFIG, SECTION_REQUIRED_CATEGORIES } from '@/lib/tracking/config'

/**
 * Invia un evento GTM con la configurazione appropriata
 * @param category - Categoria dell'evento GTM
 * @param additionalData - Dati aggiuntivi specifici per la categoria (es. section)
 * @throws Error se la configurazione è invalida o mancano dati richiesti
 *
 * @example
 * dispatchGTMEvent(GTM_EVENT_CATEGORY.DONATION, { section: 'header' })
 * dispatchGTMEvent(GTM_EVENT_CATEGORY.NEWSLETTER)
 *
 */
export function dispatchGTMEvent<T extends GTM_EVENT_CATEGORY>(
  category: T,
  additionalData?: Partial<Omit<GTMEventMap[T], keyof GTMEventBase>>
): void {
  try {
    const config = GTM_CONFIG?.[category]

    if (!config) {
      throw new Error(`Invalid GTM configuration for category: ${category}`)
    }

    const needsSection = SECTION_REQUIRED_CATEGORIES.has(category)
    if (needsSection && !('section' in (additionalData || {}))) {
      throw new Error(`Section is required for ${category} events`)
    }

    const eventData = {
      ...config,
      ...additionalData,
    } as GTMEventMap[T]
    console.info('📡[GTM EVENT]:', {
      category,
      eventData,
    })

    sendGTMEvent(eventData)
  } catch (error) {
    console.error('❌[GTM ERROR]:', error)
    throw error
  }
}
